import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/index.css';
import { initTelegram } from '@/shared/tg';
import { ErrorBoundary } from '@/shared/ErrorBoundary';
import { App } from './App';

initTelegram();

// Чанк, не доехавший после выката, — самая частая причина белого экрана:
// перезагрузка подтягивает свежие файлы
window.addEventListener('vite:preloadError', () => location.reload());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary title="Витрина не открылась">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
